export const travelLocations = [
    {
        CityId: 'US36N0028',
        CityName: 'New York',
        Country: 'US',
        Label: 'New York, NY',
        Latitude: 40.748,
        Longitude: -73.9862,
        RouteString: 'new-york-ny-10001',
        SlugName: 'new-york-ny-10001',
        StateCode: 'NY',
        Territory: 'New York',
        Zip: '10001'
    },
    {
        CityId: 'US11W0001',
        CityName: 'Washington',
        Country: 'US',
        Label: 'Washington, DC',
        Latitude: 38.8989,
        Longitude: -77.0279,
        RouteString: 'washington-dc-20001',
        SlugName: 'washington-dc-20001',
        StateCode: 'DC',
        Territory: 'District of Columbia',
        Zip: '20001'
    },
    {
        CityId: 'US12O0021',
        CityName: 'Orlando',
        Country: 'US',
        Label: 'Orlando, FL',
        Latitude: 28.521,
        Longitude: -81.3307,
        RouteString: 'orlando-fl-32812',
        SlugName: 'orlando-fl-32812',
        StateCode: 'FL',
        Territory: 'Florida',
        Zip: '32812'
    },
    {
        CityId: 'US32L0002',
        CityName: 'Las Vegas',
        Country: 'US',
        Label: 'Las Vegas, NV',
        Latitude: 36.1509,
        Longitude: -115.1967,
        RouteString: 'las-vegas-nv-89102',
        SlugName: 'las-vegas-nv-89102',
        StateCode: 'NV',
        Territory: 'Nevada',
        Zip: '89102'
    },
    {
        CityId: 'US06S0018',
        CityName: 'San Francisco',
        Country: 'US',
        Label: 'San Francisco, CA',
        Latitude: 37.7687,
        Longitude: -122.4229,
        RouteString: 'san-francisco-ca-94103',
        SlugName: 'san-francisco-ca-94103',
        StateCode: 'CA',
        Territory: 'California',
        Zip: '94103'
    },
    {
        CityId: 'US48A0056',
        CityName: 'Austin',
        Country: 'US',
        Dma: '635',
        Label: 'Austin, TX',
        Latitude: 30.2994,
        Longitude: -97.7549,
        RouteString: 'austin-tx-78703',
        SlugName: 'austin-tx-78703',
        StateCode: 'TX',
        Territory: 'Texas',
        Zip: '78703'
    }
];
